import {
  SnippetRenderer,
  SnippetsWrapper as SpicySnippetsWrapper,
} from '@grofers/react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const SnippetizedList = (props) => {
  const dispatch = useDispatch();
  const dummyReducer =
    (dispatch) =>
    (initialState = null, action) => {
      return null;
    };

  const dummyDipatcher = () => {
    return null;
  };

  return (
    <SpicySnippetsWrapper
      reducer={dummyReducer(dispatch)}
      trackingDispatcher={dummyDipatcher}
    >
      <LayoutRendererWithoutVirtualiser {...props} />
    </SpicySnippetsWrapper>
  );
};

function LayoutRendererWithoutVirtualiser({
  layout_config: layoutConfig,
  snippets,
}) {
  if (!snippets) return <></>;

  return (
    <PageLayout layoutConfig={layoutConfig}>
      {snippets.map((snippet, index) => {
        return (
          <SnippetRenderer
            key={`${snippet.widget_type}${index}`}
            {...snippet}
          />
        );
      })}
    </PageLayout>
  );
}

function PageLayout({ layoutConfig, children }) {
  return (
    <div
      className='page-layout'
      style={{
        background: layoutConfig?.bg_color_hex,
        maxWidth: layoutConfig?.max_width,
        ...(layoutConfig?.max_width && { margin: '0 auto' }),
        minHeight: '100vh',
      }}
    >
      {children}
    </div>
  );
}

export default SnippetizedList;
